export default "__VITE_ASSET__f050ab64__"